module.exports = __webpack_public_path__ + "img/sol1.cd0a1fa0.png";